export default __webpack_public_path__ + "static/media/timer.34339b6b.gif";